// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppointmentCard-module__font-s-10___yIW7j {
  font-size: 10px !important;
}

.AppointmentCard-module__font-s-12___xYSWv {
  font-size: 12px !important;
}

.AppointmentCard-module__font-s-13___RsDJS {
  font-size: 13px !important;
}

.AppointmentCard-module__font-s-14___ttcZS {
  font-size: 14px !important;
}

.AppointmentCard-module__font-s-15___kMopj {
  font-size: 15px !important;
}

.AppointmentCard-module__font-s-16___QiN2x {
  font-size: 16px !important;
}

.AppointmentCard-module__font-s-18___ztNpt {
  font-size: 18px !important;
}

.AppointmentCard-module__font-s-20___Vbw1T {
  font-size: 20px !important;
}

.AppointmentCard-module__font-s-22____mYzl {
  font-size: 22px !important;
}

.AppointmentCard-module__font-s-28___uUIth {
  font-size: 28px !important;
}

.AppointmentCard-module__font-w-400___flapK {
  font-weight: 400 !important;
}

.AppointmentCard-module__font-w-500___Gp9HP {
  font-weight: 500 !important;
}

.AppointmentCard-module__font-w-600___KFM5v {
  font-weight: 600 !important;
}

.AppointmentCard-module__font-w-700___mLoWD {
  font-weight: 700 !important;
}

.AppointmentCard-module__p-5___cuio7 {
  padding: 5px !important;
}

.AppointmentCard-module__p-12___pLTFv {
  padding: 12px !important;
}

.AppointmentCard-module__p-16___g4vyZ {
  padding: 16px !important;
}

.AppointmentCard-module__p-30___rMsrI {
  padding: 30px !important;
}

.AppointmentCard-module__p-b-0___pXHTy {
  padding-bottom: 0 !important;
}

.AppointmentCard-module__p-b-5___CgyDD {
  padding-bottom: 5px !important;
}

.AppointmentCard-module__p-b-10___v7T08 {
  padding-bottom: 10px !important;
}

.AppointmentCard-module__p-b-12___YepvE {
  padding-bottom: 12px !important;
}

.AppointmentCard-module__p-b-16___yW9hC {
  padding-bottom: 16px !important;
}

.AppointmentCard-module__p-b-18___hYdKf {
  padding-bottom: 18px !important;
}

.AppointmentCard-module__p-b-20___Hy6Vh {
  padding-bottom: 20px !important;
}

.AppointmentCard-module__p-b-25___DX5dP {
  padding-bottom: 25px !important;
}

.AppointmentCard-module__p-b-30___Hlumu {
  padding-bottom: 30px !important;
}

.AppointmentCard-module__p-b-50___FvGND {
  padding-bottom: 50px !important;
}

.AppointmentCard-module__p-t-0___BTKXZ {
  padding-top: 0 !important;
}

.AppointmentCard-module__p-t-12___tTXZd {
  padding-top: 12px !important;
}

.AppointmentCard-module__p-t-16___MpA9D {
  padding-top: 16px !important;
}

.AppointmentCard-module__p-t-18___pxdxJ {
  padding-top: 18px !important;
}

.AppointmentCard-module__p-t-20___wDwr1 {
  padding-top: 20px !important;
}

.AppointmentCard-module__p-t-30___ISqMG {
  padding-top: 30px !important;
}

.AppointmentCard-module__p-t-40___lZvjm {
  padding-top: 40px !important;
}

.AppointmentCard-module__p-t-50___lLonQ {
  padding-top: 50px !important;
}

.AppointmentCard-module__p-l-20___MX8Dd {
  padding-left: 20px !important;
}

.AppointmentCard-module__p-l-30___gmAWm {
  padding-left: 30px !important;
}

.AppointmentCard-module__p-l-40___q_PVp {
  padding-left: 40px !important;
}

.AppointmentCard-module__p-r-16___HS6Qn {
  padding-right: 16px !important;
}

.AppointmentCard-module__p-r-20___VTcPO {
  padding-right: 20px !important;
}

.AppointmentCard-module__p-r-30___wTiEp {
  padding-right: 30px !important;
}

.AppointmentCard-module__p-r-50___L0sjL {
  padding-right: 50px !important;
}

.AppointmentCard-module__p-r-60___dH86A {
  padding-right: 60px !important;
}

.AppointmentCard-module__m-b-1___G4t0Q {
  margin-bottom: 1px !important;
}

.AppointmentCard-module__m-b-2___PrBcy {
  margin-bottom: 2px !important;
}

.AppointmentCard-module__m-b-6___UOvAY {
  margin-bottom: 6px !important;
}

.AppointmentCard-module__m-b-8___mSAZ3 {
  margin-bottom: 8px !important;
}

.AppointmentCard-module__m-b-10___hJ5x7 {
  margin-bottom: 10px !important;
}

.AppointmentCard-module__m-b-14____EMjx {
  margin-bottom: 14px !important;
}

.AppointmentCard-module__m-b-16___ZSjCK {
  margin-bottom: 16px !important;
}

.AppointmentCard-module__m-b-20___s9MEa {
  margin-bottom: 20px !important;
}

.AppointmentCard-module__m-b-22___sDHHu {
  margin-bottom: 22px !important;
}

.AppointmentCard-module__m-b-24___Yhbhm {
  margin-bottom: 24px !important;
}

.AppointmentCard-module__m-b-30___OABKX {
  margin-bottom: 30px !important;
}

.AppointmentCard-module__m-b-32___EA_kO {
  margin-bottom: 32px !important;
}

.AppointmentCard-module__m-b-40___sEOV6 {
  margin-bottom: 40px !important;
}

.AppointmentCard-module__m-t-2___b3MvV {
  margin-top: 2px !important;
}

.AppointmentCard-module__m-t-3___t9G4u {
  margin-top: 3px !important;
}

.AppointmentCard-module__m-t-4___gq9eX {
  margin-top: 4px !important;
}

.AppointmentCard-module__m-t-5___GT1xe {
  margin-top: 5px !important;
}

.AppointmentCard-module__m-t-8___EUmVo {
  margin-top: 8px !important;
}

.AppointmentCard-module__m-t-10___2Tbw0 {
  margin-top: 10px !important;
}

.AppointmentCard-module__m-t-15___Z2qTl {
  margin-top: 15px !important;
}

.AppointmentCard-module__m-t-16___JqNrY {
  margin-top: 16px !important;
}

.AppointmentCard-module__m-t-20___QPE9w {
  margin-top: 20px !important;
}

.AppointmentCard-module__m-t-22___v45Gg {
  margin-top: 22px !important;
}

.AppointmentCard-module__m-t-30___FkJ5z {
  margin-top: 30px !important;
}

.AppointmentCard-module__m-t-32___KHdPZ {
  margin-top: 32px !important;
}

.AppointmentCard-module__m-l-auto___LTodr {
  margin-left: auto !important;
}

.AppointmentCard-module__m-l-4___jFZsO {
  margin-left: 4px !important;
}

.AppointmentCard-module__m-l-5___x8oaU {
  margin-left: 5px !important;
}

.AppointmentCard-module__m-l-6___mysWA {
  margin-left: 6px !important;
}

.AppointmentCard-module__m-l-8___KDT9O {
  margin-left: 8px !important;
}

.AppointmentCard-module__m-l-10___kDITq {
  margin-left: 10px !important;
}

.AppointmentCard-module__m-l-16___vqxQL {
  margin-left: 16px !important;
}

.AppointmentCard-module__m-l-20___iyPdX {
  margin-left: 20px !important;
}

.AppointmentCard-module__m-l-24___ns8zD {
  margin-left: 24px !important;
}

.AppointmentCard-module__m-l-30___rmp8n {
  margin-left: 30px !important;
}

.AppointmentCard-module__m-l-35___J9VSB {
  margin-left: 35px !important;
}

.AppointmentCard-module__m-l-40___WIRbW {
  margin-left: 40px !important;
}

.AppointmentCard-module__m-r-8___FzdCo {
  margin-right: 8px !important;
}

.AppointmentCard-module__m-r-10___WfDrF {
  margin-right: 10px !important;
}

.AppointmentCard-module__m-r-16___uaxbD {
  margin-right: 16px !important;
}

.AppointmentCard-module__m-r-20___qoqps {
  margin-right: 20px !important;
}

.AppointmentCard-module__m-r-24___pLcwe {
  margin-right: 24px !important;
}

.AppointmentCard-module__m-r-30___dhVbL {
  margin-right: 30px !important;
}

.AppointmentCard-module__m-r-40___J00FM {
  margin-right: 40px !important;
}

.AppointmentCard-module__border-r-3___visEh {
  border-radius: 3px !important;
}

.AppointmentCard-module__border-r-4___HMMcO {
  border-radius: 4px !important;
}

.AppointmentCard-module__border-r-6___QheBS {
  border-radius: 6px !important;
}

.AppointmentCard-module__border-r-10___KkU69 {
  border-radius: 10px !important;
}

.AppointmentCard-module__border-r-12___z1zG_ {
  border-radius: 12px !important;
}

.AppointmentCard-module__border-r-16___pGRQb {
  border-radius: 16px !important;
}

.AppointmentCard-module__border-r-50___t3K5q {
  border-radius: 50% !important;
}

.AppointmentCard-module__primary-border___TunZW {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.AppointmentCard-module__primary-border-b___k8K5m {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.AppointmentCard-module__primary-border-t___OafVJ {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.AppointmentCard-module__primary-border-l___M7fXB {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.AppointmentCard-module__primary-border-r___qV2A4 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.AppointmentCard-module__secondary-border___OHHxY {
  border: 1px solid #637768;
}

.AppointmentCard-module__secondary-border-b___t8wL8 {
  border-bottom: 1px solid #637768;
}

.AppointmentCard-module__secondary-border-t___Tyl7O {
  border-top: 1px solid #637768;
}

.AppointmentCard-module__secondary-border-l___WUGBT {
  border-left: 1px solid #637768;
}

.AppointmentCard-module__secondary-border-r___KWVQp {
  border-right: 1px solid #637768;
}

.AppointmentCard-module__gap-0___Db3aL {
  gap: 0 !important;
}

.AppointmentCard-module__gap-2___MmAaR {
  gap: 2px !important;
}

.AppointmentCard-module__gap-4___Cr5K2 {
  gap: 4px !important;
}

.AppointmentCard-module__gap-5___ED0uR {
  gap: 5px !important;
}

.AppointmentCard-module__gap-6___tq9UI {
  gap: 6px !important;
}

.AppointmentCard-module__gap-8___zwuvf {
  gap: 8px !important;
}

.AppointmentCard-module__gap-10___FvL_5 {
  gap: 10px !important;
}

.AppointmentCard-module__gap-12___dDhu8 {
  gap: 12px !important;
}

.AppointmentCard-module__gap-14___K7MaA {
  gap: 14px !important;
}

.AppointmentCard-module__gap-16___b5brZ {
  gap: 16px !important;
}

.AppointmentCard-module__gap-18___Ac2FB {
  gap: 18px !important;
}

.AppointmentCard-module__gap-20____2VHa {
  gap: 20px !important;
}

.AppointmentCard-module__gap-24___PhKUO {
  gap: 24px !important;
}

.AppointmentCard-module__gap-26___SN0vf {
  gap: 26px !important;
}

.AppointmentCard-module__gap-30___tvaJq {
  gap: 30px !important;
}

.AppointmentCard-module__gap-32___BAxrC {
  gap: 32px !important;
}

.AppointmentCard-module__gap-40___cZssO {
  gap: 40px !important;
}

.AppointmentCard-module__gap-50___dljuB {
  gap: 50px !important;
}

.AppointmentCard-module__flex-1___m5cy_ {
  flex: 1;
}

.AppointmentCard-module__flex-none___KHq0K {
  flex: none !important;
}

.AppointmentCard-module__flex-column___MDDEq {
  display: flex;
  flex-direction: column !important;
}

.AppointmentCard-module__flex-row___VPVSU {
  display: flex;
  flex-direction: row !important;
}

.AppointmentCard-module__vertically-centered___kbeam {
  display: flex;
  align-items: center !important;
}

.AppointmentCard-module__horizontally-centered___i4pcg {
  display: flex;
  justify-content: center !important;
}

.AppointmentCard-module__horizontally-end___J9gsC {
  display: flex;
  justify-content: end !important;
}

.AppointmentCard-module__vertically-start___UJ9WH {
  display: flex;
  align-items: start !important;
}

.AppointmentCard-module__space-between___uy3cv {
  display: flex;
  justify-content: space-between !important;
}

.AppointmentCard-module__flex-wrap___CuAHU {
  flex-wrap: wrap !important;
}

.AppointmentCard-module__height-100___Zklmb {
  height: 100%;
}

.AppointmentCard-module__width-50___n4yGV {
  width: 50% !important;
}

.AppointmentCard-module__width-100___ylB24 {
  width: 100%;
}

.AppointmentCard-module__cursor-pointer___CusMQ {
  cursor: pointer;
}

.AppointmentCard-module__cursor-not-allowed___A8Zpr {
  cursor: not-allowed !important;
}

.AppointmentCard-module__absolute-centered___ECP6j {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.AppointmentCard-module__absolute___dmLbS {
  position: absolute;
}

.AppointmentCard-module__relative___kKLuB {
  position: relative;
}

.AppointmentCard-module__fixed___FBpHM {
  position: fixed;
}

.AppointmentCard-module__visible___xlo22 {
  opacity: 1;
}

.AppointmentCard-module__invisible___FeE3f {
  opacity: 0;
}

.AppointmentCard-module__col-90___U12aJ {
  width: 90% !important;
}

.AppointmentCard-module__col-auto___ynBKc {
  width: auto !important;
}

.AppointmentCard-module__medical-tabs___cuCXs {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.AppointmentCard-module__medical-table-new___hT4eR {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AppointmentCard-module__medical-table-new___hT4eR:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AppointmentCard-module__medical-table-new___hT4eR::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AppointmentCard-module__medical-table-new___hT4eR::-webkit-scrollbar-track {
  display: none;
}
.AppointmentCard-module__medical-table-new___hT4eR.AppointmentCard-module__no-pagination___OkUks {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AppointmentCard-module__medical-table-new___hT4eR.AppointmentCard-module__no-pagination___OkUks:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AppointmentCard-module__medical-table-new___hT4eR.AppointmentCard-module__no-pagination___OkUks::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AppointmentCard-module__medical-table-new___hT4eR.AppointmentCard-module__no-pagination___OkUks::-webkit-scrollbar-track {
  display: none;
}

.AppointmentCard-module__medical-table-empty___ZmCa0 {
  padding: 14px 40px !important;
}

.AppointmentCard-module__icon-btn___sokLK {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.AppointmentCard-module__search-icon___hRyh4 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.AppointmentCard-module__disable-select___tXZ60 {
  user-select: none;
}

.AppointmentCard-module__break-word___qz8Ey {
  word-break: break-word;
}

.AppointmentCard-module__popup-clear-btn___qu0sc {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.AppointmentCard-module__scroll-m-b-20___O01EV {
  scroll-margin-bottom: 20px;
}

.AppointmentCard-module__memberName___m7k7t {
  font-size: 15px;
  font-weight: 600;
  color: #18181b;
}

.AppointmentCard-module__dismiss___YYWnr {
  display: inline-flex;
  width: 0;
  margin-left: -6px;
  padding: 2px 0;
  overflow: hidden;
  border: 0;
  border-radius: 2px;
  background: transparent;
  color: #a1a1aa;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s;
  outline: none;
}
.AppointmentCard-module__dismiss___YYWnr:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}
.AppointmentCard-module__dismiss___YYWnr:hover {
  color: #52525b;
}
.AppointmentCard-module__dismiss___YYWnr:focus-visible {
  width: auto;
  margin-left: 0;
  padding: 2px;
  opacity: 1;
}

[data-visit-card]:hover .AppointmentCard-module__dismiss___YYWnr {
  width: auto;
  margin-left: 0;
  padding: 2px;
  opacity: 1;
}

.AppointmentCard-module__srOnly___oTs8_ {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/AppointmentCard/AppointmentCard.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,oBAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,yBAAA;EEmBA,aAAA;AF4oBF;AE1oBE;EACE,0BAAA;EACA,mBALuB;AFipB3B;AAhqBE;EACE,cAAA;AAkqBJ;AA/pBE;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;AAiqBJ;;AA7pBA;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;AAgqBF;;AA7pBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AAgqBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.memberName {\n  font-size: 15px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.dismiss {\n  display: inline-flex;\n  width: 0;\n  margin-left: -6px;\n  padding: 2px 0;\n  overflow: hidden;\n  border: 0;\n  border-radius: 2px;\n  background: transparent;\n  color: #a1a1aa;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.15s;\n  @include focus-ring;\n\n  &:hover {\n    color: #52525b;\n  }\n\n  &:focus-visible {\n    width: auto;\n    margin-left: 0;\n    padding: 2px;\n    opacity: 1;\n  }\n}\n\n:global([data-visit-card]):hover .dismiss {\n  width: auto;\n  margin-left: 0;\n  padding: 2px;\n  opacity: 1;\n}\n\n.srOnly {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `AppointmentCard-module__font-s-10___yIW7j`,
	"fontS12": `AppointmentCard-module__font-s-12___xYSWv`,
	"fontS13": `AppointmentCard-module__font-s-13___RsDJS`,
	"fontS14": `AppointmentCard-module__font-s-14___ttcZS`,
	"fontS15": `AppointmentCard-module__font-s-15___kMopj`,
	"fontS16": `AppointmentCard-module__font-s-16___QiN2x`,
	"fontS18": `AppointmentCard-module__font-s-18___ztNpt`,
	"fontS20": `AppointmentCard-module__font-s-20___Vbw1T`,
	"fontS22": `AppointmentCard-module__font-s-22____mYzl`,
	"fontS28": `AppointmentCard-module__font-s-28___uUIth`,
	"fontW400": `AppointmentCard-module__font-w-400___flapK`,
	"fontW500": `AppointmentCard-module__font-w-500___Gp9HP`,
	"fontW600": `AppointmentCard-module__font-w-600___KFM5v`,
	"fontW700": `AppointmentCard-module__font-w-700___mLoWD`,
	"p5": `AppointmentCard-module__p-5___cuio7`,
	"p12": `AppointmentCard-module__p-12___pLTFv`,
	"p16": `AppointmentCard-module__p-16___g4vyZ`,
	"p30": `AppointmentCard-module__p-30___rMsrI`,
	"pB0": `AppointmentCard-module__p-b-0___pXHTy`,
	"pB5": `AppointmentCard-module__p-b-5___CgyDD`,
	"pB10": `AppointmentCard-module__p-b-10___v7T08`,
	"pB12": `AppointmentCard-module__p-b-12___YepvE`,
	"pB16": `AppointmentCard-module__p-b-16___yW9hC`,
	"pB18": `AppointmentCard-module__p-b-18___hYdKf`,
	"pB20": `AppointmentCard-module__p-b-20___Hy6Vh`,
	"pB25": `AppointmentCard-module__p-b-25___DX5dP`,
	"pB30": `AppointmentCard-module__p-b-30___Hlumu`,
	"pB50": `AppointmentCard-module__p-b-50___FvGND`,
	"pT0": `AppointmentCard-module__p-t-0___BTKXZ`,
	"pT12": `AppointmentCard-module__p-t-12___tTXZd`,
	"pT16": `AppointmentCard-module__p-t-16___MpA9D`,
	"pT18": `AppointmentCard-module__p-t-18___pxdxJ`,
	"pT20": `AppointmentCard-module__p-t-20___wDwr1`,
	"pT30": `AppointmentCard-module__p-t-30___ISqMG`,
	"pT40": `AppointmentCard-module__p-t-40___lZvjm`,
	"pT50": `AppointmentCard-module__p-t-50___lLonQ`,
	"pL20": `AppointmentCard-module__p-l-20___MX8Dd`,
	"pL30": `AppointmentCard-module__p-l-30___gmAWm`,
	"pL40": `AppointmentCard-module__p-l-40___q_PVp`,
	"pR16": `AppointmentCard-module__p-r-16___HS6Qn`,
	"pR20": `AppointmentCard-module__p-r-20___VTcPO`,
	"pR30": `AppointmentCard-module__p-r-30___wTiEp`,
	"pR50": `AppointmentCard-module__p-r-50___L0sjL`,
	"pR60": `AppointmentCard-module__p-r-60___dH86A`,
	"mB1": `AppointmentCard-module__m-b-1___G4t0Q`,
	"mB2": `AppointmentCard-module__m-b-2___PrBcy`,
	"mB6": `AppointmentCard-module__m-b-6___UOvAY`,
	"mB8": `AppointmentCard-module__m-b-8___mSAZ3`,
	"mB10": `AppointmentCard-module__m-b-10___hJ5x7`,
	"mB14": `AppointmentCard-module__m-b-14____EMjx`,
	"mB16": `AppointmentCard-module__m-b-16___ZSjCK`,
	"mB20": `AppointmentCard-module__m-b-20___s9MEa`,
	"mB22": `AppointmentCard-module__m-b-22___sDHHu`,
	"mB24": `AppointmentCard-module__m-b-24___Yhbhm`,
	"mB30": `AppointmentCard-module__m-b-30___OABKX`,
	"mB32": `AppointmentCard-module__m-b-32___EA_kO`,
	"mB40": `AppointmentCard-module__m-b-40___sEOV6`,
	"mT2": `AppointmentCard-module__m-t-2___b3MvV`,
	"mT3": `AppointmentCard-module__m-t-3___t9G4u`,
	"mT4": `AppointmentCard-module__m-t-4___gq9eX`,
	"mT5": `AppointmentCard-module__m-t-5___GT1xe`,
	"mT8": `AppointmentCard-module__m-t-8___EUmVo`,
	"mT10": `AppointmentCard-module__m-t-10___2Tbw0`,
	"mT15": `AppointmentCard-module__m-t-15___Z2qTl`,
	"mT16": `AppointmentCard-module__m-t-16___JqNrY`,
	"mT20": `AppointmentCard-module__m-t-20___QPE9w`,
	"mT22": `AppointmentCard-module__m-t-22___v45Gg`,
	"mT30": `AppointmentCard-module__m-t-30___FkJ5z`,
	"mT32": `AppointmentCard-module__m-t-32___KHdPZ`,
	"mLAuto": `AppointmentCard-module__m-l-auto___LTodr`,
	"mL4": `AppointmentCard-module__m-l-4___jFZsO`,
	"mL5": `AppointmentCard-module__m-l-5___x8oaU`,
	"mL6": `AppointmentCard-module__m-l-6___mysWA`,
	"mL8": `AppointmentCard-module__m-l-8___KDT9O`,
	"mL10": `AppointmentCard-module__m-l-10___kDITq`,
	"mL16": `AppointmentCard-module__m-l-16___vqxQL`,
	"mL20": `AppointmentCard-module__m-l-20___iyPdX`,
	"mL24": `AppointmentCard-module__m-l-24___ns8zD`,
	"mL30": `AppointmentCard-module__m-l-30___rmp8n`,
	"mL35": `AppointmentCard-module__m-l-35___J9VSB`,
	"mL40": `AppointmentCard-module__m-l-40___WIRbW`,
	"mR8": `AppointmentCard-module__m-r-8___FzdCo`,
	"mR10": `AppointmentCard-module__m-r-10___WfDrF`,
	"mR16": `AppointmentCard-module__m-r-16___uaxbD`,
	"mR20": `AppointmentCard-module__m-r-20___qoqps`,
	"mR24": `AppointmentCard-module__m-r-24___pLcwe`,
	"mR30": `AppointmentCard-module__m-r-30___dhVbL`,
	"mR40": `AppointmentCard-module__m-r-40___J00FM`,
	"borderR3": `AppointmentCard-module__border-r-3___visEh`,
	"borderR4": `AppointmentCard-module__border-r-4___HMMcO`,
	"borderR6": `AppointmentCard-module__border-r-6___QheBS`,
	"borderR10": `AppointmentCard-module__border-r-10___KkU69`,
	"borderR12": `AppointmentCard-module__border-r-12___z1zG_`,
	"borderR16": `AppointmentCard-module__border-r-16___pGRQb`,
	"borderR50": `AppointmentCard-module__border-r-50___t3K5q`,
	"primaryBorder": `AppointmentCard-module__primary-border___TunZW`,
	"primaryBorderB": `AppointmentCard-module__primary-border-b___k8K5m`,
	"primaryBorderT": `AppointmentCard-module__primary-border-t___OafVJ`,
	"primaryBorderL": `AppointmentCard-module__primary-border-l___M7fXB`,
	"primaryBorderR": `AppointmentCard-module__primary-border-r___qV2A4`,
	"secondaryBorder": `AppointmentCard-module__secondary-border___OHHxY`,
	"secondaryBorderB": `AppointmentCard-module__secondary-border-b___t8wL8`,
	"secondaryBorderT": `AppointmentCard-module__secondary-border-t___Tyl7O`,
	"secondaryBorderL": `AppointmentCard-module__secondary-border-l___WUGBT`,
	"secondaryBorderR": `AppointmentCard-module__secondary-border-r___KWVQp`,
	"gap0": `AppointmentCard-module__gap-0___Db3aL`,
	"gap2": `AppointmentCard-module__gap-2___MmAaR`,
	"gap4": `AppointmentCard-module__gap-4___Cr5K2`,
	"gap5": `AppointmentCard-module__gap-5___ED0uR`,
	"gap6": `AppointmentCard-module__gap-6___tq9UI`,
	"gap8": `AppointmentCard-module__gap-8___zwuvf`,
	"gap10": `AppointmentCard-module__gap-10___FvL_5`,
	"gap12": `AppointmentCard-module__gap-12___dDhu8`,
	"gap14": `AppointmentCard-module__gap-14___K7MaA`,
	"gap16": `AppointmentCard-module__gap-16___b5brZ`,
	"gap18": `AppointmentCard-module__gap-18___Ac2FB`,
	"gap20": `AppointmentCard-module__gap-20____2VHa`,
	"gap24": `AppointmentCard-module__gap-24___PhKUO`,
	"gap26": `AppointmentCard-module__gap-26___SN0vf`,
	"gap30": `AppointmentCard-module__gap-30___tvaJq`,
	"gap32": `AppointmentCard-module__gap-32___BAxrC`,
	"gap40": `AppointmentCard-module__gap-40___cZssO`,
	"gap50": `AppointmentCard-module__gap-50___dljuB`,
	"flex1": `AppointmentCard-module__flex-1___m5cy_`,
	"flexNone": `AppointmentCard-module__flex-none___KHq0K`,
	"flexColumn": `AppointmentCard-module__flex-column___MDDEq`,
	"flexRow": `AppointmentCard-module__flex-row___VPVSU`,
	"verticallyCentered": `AppointmentCard-module__vertically-centered___kbeam`,
	"horizontallyCentered": `AppointmentCard-module__horizontally-centered___i4pcg`,
	"horizontallyEnd": `AppointmentCard-module__horizontally-end___J9gsC`,
	"verticallyStart": `AppointmentCard-module__vertically-start___UJ9WH`,
	"spaceBetween": `AppointmentCard-module__space-between___uy3cv`,
	"flexWrap": `AppointmentCard-module__flex-wrap___CuAHU`,
	"height100": `AppointmentCard-module__height-100___Zklmb`,
	"width50": `AppointmentCard-module__width-50___n4yGV`,
	"width100": `AppointmentCard-module__width-100___ylB24`,
	"cursorPointer": `AppointmentCard-module__cursor-pointer___CusMQ`,
	"cursorNotAllowed": `AppointmentCard-module__cursor-not-allowed___A8Zpr`,
	"absoluteCentered": `AppointmentCard-module__absolute-centered___ECP6j`,
	"absolute": `AppointmentCard-module__absolute___dmLbS`,
	"relative": `AppointmentCard-module__relative___kKLuB`,
	"fixed": `AppointmentCard-module__fixed___FBpHM`,
	"visible": `AppointmentCard-module__visible___xlo22`,
	"invisible": `AppointmentCard-module__invisible___FeE3f`,
	"col90": `AppointmentCard-module__col-90___U12aJ`,
	"colAuto": `AppointmentCard-module__col-auto___ynBKc`,
	"medicalTabs": `AppointmentCard-module__medical-tabs___cuCXs`,
	"medicalTableNew": `AppointmentCard-module__medical-table-new___hT4eR`,
	"noPagination": `AppointmentCard-module__no-pagination___OkUks`,
	"medicalTableEmpty": `AppointmentCard-module__medical-table-empty___ZmCa0`,
	"iconBtn": `AppointmentCard-module__icon-btn___sokLK`,
	"searchIcon": `AppointmentCard-module__search-icon___hRyh4`,
	"disableSelect": `AppointmentCard-module__disable-select___tXZ60`,
	"breakWord": `AppointmentCard-module__break-word___qz8Ey`,
	"popupClearBtn": `AppointmentCard-module__popup-clear-btn___qu0sc`,
	"scrollMB20": `AppointmentCard-module__scroll-m-b-20___O01EV`,
	"memberName": `AppointmentCard-module__memberName___m7k7t`,
	"dismiss": `AppointmentCard-module__dismiss___YYWnr`,
	"srOnly": `AppointmentCard-module__srOnly___oTs8_`
};
module.exports = ___CSS_LOADER_EXPORT___;
